/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { IntlProvider } from 'react-intl';
import { messages } from '../languages/translations';
import { LocaleContext } from '../languages/LocaleProvider';
import React from 'react';

export default (props) => (
	<LocaleContext.Consumer>
		{({ locale }) => <IntlProvider locale={locale} messages={messages[locale]} {...props} />}
	</LocaleContext.Consumer>
);
